import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { Panel } from 'primereact/panel';
import _ from 'lodash';
import { Card } from 'primereact/card';
import { connect } from 'react-redux';
import { defineMessages, injectIntl } from 'react-intl';


const i18nMessages = defineMessages({
  headerSupLanguage: {
    id: 'attrs.support_lang.supportedLanguages',
    defaultMessage: 'Supported Languages',
  },
  headerQuestionnaire: {
    id: 'attrs.support_lang.questionnaire',
    defaultMessage: 'Questionnaire',
  },
  headerReport: {
    id: 'attrs.support_lang.report',
    defaultMessage: 'Report',
  },
});


const SurveyTemplateLanguages = ({
  formValues, surveyCompetencies, translatedTags, intl: { formatMessage },
}) => {
  const [formAbilitiesIds, setFormAbilitiesIds] = useState([]);
  const [surveyAbilities, setSurveyAbilities] = useState([]);

  const [supportedQuestionnaireLangTags, setSupportedQuestionnaireLangTags] = useState([]);
  const [supportedReportLangTags, setSupportedReportLangTags] = useState([]);

  useEffect(() => {
    setFormAbilitiesIds(formValues.abilities.map(ab => ab.abilityId));
    setSurveyAbilities(_.flatten(surveyCompetencies.map(sc => sc.abilities)));
  },
  [formValues.abilities, surveyCompetencies]);

  useEffect(() => {
    let questLangTags = [];
    let reportLangTags = [];

    formAbilitiesIds.forEach((faId) => {
      const surveyAbility = surveyAbilities.find(sa => sa.id === faId);

      if (surveyAbility) {
        questLangTags = questLangTags.length === 0
          ? surveyAbility.questionnaireLanguages
          : _.intersection(questLangTags, surveyAbility.questionnaireLanguages);

        reportLangTags = reportLangTags.length === 0
          ? surveyAbility.reportLanguages
          : _.intersection(reportLangTags, surveyAbility.reportLanguages);
      }
    });

    setSupportedQuestionnaireLangTags(questLangTags);
    setSupportedReportLangTags(reportLangTags);
  }, [formAbilitiesIds, surveyAbilities]);


  const getTranslatedTag = (tag) => {
    const foundTranslatedTag = translatedTags.find(tt => tt.value === tag);
    return foundTranslatedTag ? foundTranslatedTag.label : tag;
  };

  return (
    <Panel
      header={formatMessage(i18nMessages.headerSupLanguage)}
      className="p-col-4"
      style={{ paddingLeft: '5px' }}
    >
      <Card
        subTitle={formatMessage(i18nMessages.headerQuestionnaire)}
        style={{ border: '1px solid lightgrey', marginBottom: '5px' }}
      >
        <ul style={{ listStyle: 'inside none none' }}>
          {
                        supportedQuestionnaireLangTags.map(sql => (
                          <li key={sql} style={{ fontStyle: 'italic' }}>
                            <i className="fa fa-check icon-success" aria-hidden="true" />
                            {` ${getTranslatedTag(sql)}`}
                          </li>
                        ))
                    }
        </ul>
      </Card>

      <Card
        subTitle={formatMessage(i18nMessages.headerReport)}
        style={{ border: '1px solid lightgrey', marginBottom: '5px' }}
      >
        <ul style={{ listStyle: 'inside none none' }}>
          {
                        supportedReportLangTags.map(srl => (
                          <li key={srl} style={{ fontStyle: 'italic' }}>
                            <i className="fa fa-check icon-success" aria-hidden="true" />
                            {` ${getTranslatedTag(srl)}`}
                          </li>
                        ))
                    }
        </ul>
      </Card>

    </Panel>
  );
};

const mapStateToProps = (state) => {
  const { translatedTags } = state.i18n;
  return {
    translatedTags,
  };
};

SurveyTemplateLanguages.propTypes = {
  formValues: PropTypes.objectOf(PropTypes.any).isRequired,
  surveyCompetencies: PropTypes.arrayOf(PropTypes.any).isRequired,
  translatedTags: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)).isRequired,
  intl: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default connect(mapStateToProps)(injectIntl(SurveyTemplateLanguages));
